import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import SearchBar from "@/components/navbars/SearchBar";
import { FORM_SIGN_LINK } from "@/utils/constants/appConstants/commonConstants";
import CopyToClipboard from "react-copy-to-clipboard";

interface FormURLsCardProps {
    form: any;
    title: string;
}

function resetCopyStateTimer() {
    return new Promise<void>((resolve) => {
        setTimeout(resolve, 5000);
    });
}

const FormURLsCard = (props: FormURLsCardProps) => {
    const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
    const [copy, setCopy] = useState<number | null>(null);
    const [search, setSearch] = useState("");
    const [showSearch, setShowSearch] = useState(false);

    const handleSearch = (searchText: string) => setSearch(searchText === "" ? "" : searchText);
    const reset = () => {
        setSearch("");
        window.scrollTo(0, 0);
    };

    const filteredLinks =
        props.form?.public_links?.filter((link: any) =>
            search?.trim() !== "" ? link.name.toLowerCase().includes(search?.toLowerCase()) : true
        ) ?? [];

    const cardTitle = props.title === "Form Responses" ? "" : props.title;

    return (
        <div className="gs-list-page-card">
            <div className="gs-list-page-card-header">
                {showSearch ? (
                    <SearchBar
                        onHide={() => setShowSearch(false)}
                        handleSearch={handleSearch}
                        reset={reset}
                        title=""
                        id="form-url-tab"
                    />
                ) : (
                    <div className="gs-list-page-header">
                        <div className="gs-list-page-title-wrap">
                            <h5 className="gs-list-page-title">{cardTitle}</h5>
                        </div>
                        <div className="gs-list-page-tools">
                            <button
                                type="button"
                                className="btn btn-icon"
                                id="form-url-tab-search-btn"
                                onClick={() => setShowSearch(true)}
                            >
                                <em className="icon ni ni-search" id="form-url-tab-search-icon" />
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {isMobile ? (
                <div className="envelope_table">
                    {filteredLinks.map((link: any, index: number) => (
                        <div className="envelope_tr" key={link?.id ?? index}>
                            <div>
                                <div className="icon mr-2 px-2 fs-5">
                                    <em className="fw-400 icon ni ni-link" />
                                </div>
                            </div>
                            <div className="env_meta_data">
                                <div className="data" style={{ maxWidth: "100%" }}>
                                    <div className="info">
                                        <div
                                            className="text-dark name d-md-none bold-Text mb-1"
                                            style={{
                                                marginTop: 4,
                                                overflow: "hidden",
                                                whiteSpace: "nowrap",
                                                textOverflow: "ellipsis",
                                                maxWidth: "70%",
                                            }}
                                        >
                                            {link?.name}
                                        </div>
                                        <div className="meta">
                                            <span className="version">
                                                <span className="text-soft">
                                                    <span className="tb-lead">
                                                        <input
                                                            value={FORM_SIGN_LINK(link?.id)}
                                                            disabled
                                                            className="form-control"
                                                        />
                                                    </span>
                                                </span>
                                            </span>
                                            <div>
                                                <div className="meta mb-1">
                                                    <span className="version">
                                                        <span className="text-dark">
                                                            Submissions: {link?.response_count}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            <div>
                                                <div className="meta mb-1">
                                                    <span className="version">
                                                        <span className="text-dark">
                                                            <CopyToClipboard
                                                                text={FORM_SIGN_LINK(link?.id)}
                                                                onCopy={() => {
                                                                    setCopy(index);
                                                                    resetCopyStateTimer().then(() => setCopy(null));
                                                                }}
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className={`btn ${copy !== index ? "btn-primary" : "btn-light"}`}
                                                                >
                                                                    {copy !== index ? "Copy" : "Copied"}
                                                                </button>
                                                            </CopyToClipboard>
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <table
                    className="nk-tb-list nk-tb-ulist table-weight gs-form-url-table"
                    style={{ tableLayout: "fixed", width: "100%" }}
                >
                    <thead>
                        <tr className="nk-tb-item nk-tb-head">
                            <th className="nk-tb-col" style={{ width: "15%" }}>
                                <span>Name</span>
                            </th>
                            <th className="nk-tb-col tb-col-mb text-left" style={{ width: "20%" }}>
                                <span>URL</span>
                            </th>
                            <th className="nk-tb-col tb-col-mb text-center" style={{ width: "10%" }}>
                                <span>Status</span>
                            </th>
                            <th className="nk-tb-col tb-col-mb text-center" style={{ width: "10%" }}>
                                <span>Submissions</span>
                            </th>
                            <th className="nk-tb-col tb-col-mb" style={{ width: "10%" }}>
                                <span>Action</span>
                            </th>
                        </tr>
                    </thead>
                    <tbody className="tb-odr-body">
                        {filteredLinks.map((link: any, index: number) => (
                            <tr className="nk-tb-item" key={link?.id ?? index}>
                                <td
                                    className="nk-tb-col"
                                    style={{ paddingTop: "1.7rem", paddingBottom: "1.7rem" }}
                                >
                                    <div
                                        className="data"
                                        style={{
                                            marginTop: 4,
                                            maxWidth: "80%",
                                            overflow: "hidden",
                                            whiteSpace: "nowrap",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        <div className="project-title">
                                            <div className="d-md-none align-middle">
                                                <em className="fw-400 icon ni ni-link text-gray fs-5 px-2 mr-2" />
                                                <span className="text-dark name font-weight-bold">{link?.name}</span>
                                            </div>
                                            <div className="tb-col-md align-middle">
                                                <em className="fw-400 icon ni ni-link text-gray fs-5 px-2 mr-2" />
                                                <span className="text-dark name font-weight-bold">{link?.name}</span>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                                <td
                                    className="nk-tb-col tb-col-mb text-left"
                                    style={{ paddingTop: "1.7rem", paddingBottom: "1.7rem" }}
                                >
                                    <span className="tb-lead">
                                        <input
                                            value={FORM_SIGN_LINK(link?.id)}
                                            disabled
                                            className="form-control"
                                        />
                                    </span>
                                </td>
                                <td
                                    className="nk-tb-col tb-col-mb text-center"
                                    style={{ paddingTop: "1.7rem", paddingBottom: "1.7rem" }}
                                >
                                    <span
                                        className={`w-50 justify-content-center badge badge-sm badge-dim ${link?.is_enabled ? "badge-outline-success" : "badge-outline-secondary"} d-none d-md-inline-flex`}
                                    >
                                        {link?.is_enabled ? "Active" : "Inactive"}
                                    </span>
                                </td>
                                <td
                                    className="nk-tb-col tb-col-mb text-center"
                                    style={{ paddingTop: "1.7rem", paddingBottom: "1.7rem" }}
                                >
                                    <span className="text-dark">{link?.response_count}</span>
                                </td>
                                <td
                                    className="nk-tb-col tb-col-mb"
                                    style={{ paddingTop: "1.7rem", paddingBottom: "1.7rem" }}
                                >
                                    <CopyToClipboard
                                        text={FORM_SIGN_LINK(link?.id)}
                                        onCopy={() => {
                                            setCopy(index);
                                            resetCopyStateTimer().then(() => setCopy(null));
                                        }}
                                    >
                                        <button
                                            type="button"
                                            className={`btn ${copy !== index ? "btn-primary" : "btn-light"}`}
                                        >
                                            {copy !== index ? "Copy" : "Copied"}
                                        </button>
                                    </CopyToClipboard>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default FormURLsCard;
